import { render, staticRenderFns } from "./PageFooter.vue?vue&type=template&id=92195072&"
import script from "./PageFooter.vue?vue&type=script&lang=js&"
export * from "./PageFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92195072')) {
      api.createRecord('92195072', component.options)
    } else {
      api.reload('92195072', component.options)
    }
    module.hot.accept("./PageFooter.vue?vue&type=template&id=92195072&", function () {
      api.rerender('92195072', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/PageFooter.vue"
export default component.exports